<template>
  <div
    class="d-flex justify-content-center align-items-center vh-100"
    style="background: linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%);"
  >
    <div
      class="card p-4 shadow-lg"
      style="max-width: 400px; width: 100%; border-radius: 20px; backdrop-filter: blur(15px);
             background: rgba(255, 255, 255, 0.25); border: 1px solid rgba(255, 255, 255, 0.3);"
    >
      <div class="text-center mb-4">
        <h1 class="text-dark mb-1 fw-bold">Rabia Solutions LTD</h1>
        <h5 class="text-dark fst-italic">Powered By - ConIT</h5>
      </div>

      <h2 class="text-center mb-4 text-dark">Welcome Back!</h2>

      <!-- Collapsible Header -->
      <div
        class="collapse-header d-flex align-items-center justify-content-between px-3 py-2 mb-3"
        @click="isOpen = !isOpen"
      >
        <div class="d-flex align-items-center">
          <i
            class="fas fa-chevron-right me-2 collapse-arrow"
            :class="{ rotate: isOpen }"
          ></i>
          <span class="fw-bold text-dark">Login Details</span>
        </div>
        <small class="text-muted" style="font-size: 0.8rem">
          {{ isOpen ? "Hide" : "Show" }}
        </small>
      </div>

      <collapse-transition>
        <form v-show="isOpen" @submit.prevent="handleLogin" autocomplete="off">
          <!-- Email -->
          <div class="mb-3">
            <label for="email" class="form-label text-dark">Email Address</label>
            <div class="input-group">
              <span class="input-group-text bg-transparent text-dark border-dark">
                <i class="fas fa-envelope"></i>
              </span>
              <input
                type="email"
                id="email"
                v-model="email"
                class="form-control bg-transparent text-dark border-dark"
                placeholder="Enter your email"
                autocomplete="username"
                required
              />
            </div>
          </div>

          <!-- Password -->
          <div class="mb-3">
            <label for="password" class="form-label text-dark">Password</label>
            <div class="input-group">
              <span class="input-group-text bg-transparent text-dark border-dark">
                <i class="fas fa-lock"></i>
              </span>
              <input
                :type="passwordVisibility ? 'text' : 'password'"
                id="password"
                v-model="password"
                class="form-control bg-transparent text-dark border-dark"
                placeholder="Enter your password"
                autocomplete="new-password"
                required
              />
              <span
                class="input-group-text bg-transparent text-dark border-dark"
                @click="togglePasswordVisibility"
                style="cursor: pointer"
              >
                <i
                  :class="passwordVisibility ? 'fas fa-eye-slash' : 'fas fa-eye'"
                ></i>
              </span>
            </div>
          </div>

          <!-- Remember Me -->
          <div class="mb-3 form-check">
            <input
              type="checkbox"
              id="remember"
              v-model="rememberMe"
              class="form-check-input"
            />
            <label for="remember" class="form-check-label text-dark">
              Remember me
            </label>
          </div>

          <!-- Login Button -->
          <button
            type="submit"
            class="btn btn-primary w-100 py-2 d-flex justify-content-center align-items-center"
            :disabled="loading"
            style="border-radius: 10px; font-weight: bold"
          >
            <span v-if="!loading">Log In</span>
            <span v-else>
              <span
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Logging in...
            </span>
          </button>
        </form>
      </collapse-transition>
      <div class="text-center mt-2">
  <a
    href="#"
    class="text-decoration-none text-primary fw-bold"
    @click.prevent="showVerifyModal = true"
  >
    Activate / Change Account Password 
  </a>
</div>

<verify-account-modal
  v-if="showVerifyModal"
  @close="showVerifyModal = false"
/>

    </div>
  </div>
</template>

<script>
import { userService } from "@/api/user.service";
import swal from "@/utils/swal";
import VerifyAccountModal from "@/components/auth/VerifyAccountModal.vue";

export default {
    components: { VerifyAccountModal },
  data() {
    return {
      showVerifyModal: false,
      email: "",
      password: "",
      rememberMe: false,
      passwordVisibility: false,
      loading: false,
      isOpen: true,
    };
  },

  mounted() {
    // Restore last used email only
    const lastEmail = localStorage.getItem("lastEmail");
    if (lastEmail) {
      this.email = lastEmail;
    }

    // Restore password ONLY if user opted for remember me
    const savedPassword = localStorage.getItem("savedPassword");
    if (savedPassword) {
      this.password = savedPassword;
      this.rememberMe = true;
    }
  },

  methods: {
    async handleLogin() {
      this.loading = true;
      try {
        const user = await userService.login(this.email, this.password);

        if (user && user.token) {
          // Always remember email
          localStorage.setItem("lastEmail", this.email);

          // Remember password only if allowed
          if (this.rememberMe) {
            localStorage.setItem("savedPassword", this.password);
          } else {
            localStorage.removeItem("savedPassword");
          }

          this.$router.push({ name: "home" });
        }
      } catch (error) {
        swal.error("Login failed: Invalid credentials or server error.");
      } finally {
        this.loading = false;
        this.password = ""; // clear password after attempt
      }
    },

    togglePasswordVisibility() {
      this.passwordVisibility = !this.passwordVisibility;
    },
  },
};
</script>

<style scoped>
.collapse-header {
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  transition: all 0.3s ease;
}

.collapse-header:hover {
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.collapse-arrow {
  transition: transform 0.3s ease;
  font-size: 1rem;
}

.collapse-arrow.rotate {
  transform: rotate(90deg);
}
</style>
